(()=>{function init(){const menu=document.querySelector('.v2-menu-dialog'),opener=document.querySelector('[data-rpl-menu]');if(!menu||!opener||opener.dataset.ready)return;opener.dataset.ready='true';opener.addEventListener('click',()=>{menu.showModal();document.body.style.overflow='hidden'});menu.querySelector('[data-rpl-close]')?.addEventListener('click',()=>menu.close());menu.addEventListener('close',()=>{document.body.style.overflow='';opener.focus()});menu.addEventListener('click',e=>{if(e.target===menu)menu.close()})}init();document.addEventListener('shopify:section:load',init)})();

(()=>{
  const initialized = new WeakSet();
  function initGalleries(){
    document.querySelectorAll('.rpl-commerce .product-gallery__carousel[adaptive-height]').forEach(carousel=>{
      if(initialized.has(carousel)) return;
      initialized.add(carousel);
      let frame;
      const resize = ()=>{
        cancelAnimationFrame(frame);
        frame = requestAnimationFrame(()=>{
          if(!carousel.isConnected) return;
          const cell = carousel.selectedCell || carousel.querySelector('.is-initial') || carousel.firstElementChild;
          if(!cell) return;
          const height = cell.getBoundingClientRect().height;
          carousel.style.maxHeight = height > 0 && carousel.scrollWidth > carousel.clientWidth + 1 ? `${Math.ceil(height)}px` : '';
        });
      };
      const observer = new ResizeObserver(resize);
      observer.observe(carousel);
      Array.from(carousel.children).forEach(cell=>observer.observe(cell));
      carousel.addEventListener('load',resize,true);
      carousel.addEventListener('carousel:select',resize);
      carousel.addEventListener('carousel:settle',resize);
      window.addEventListener('pageshow',resize);
      resize();
    });
  }
  initGalleries();
  document.addEventListener('shopify:section:load',initGalleries);
  document.addEventListener('product:rerender',()=>requestAnimationFrame(initGalleries));
})();

/* Keep extended collection stories available without pushing products down. */
(function(){
 function compactCollections(){
  document.querySelectorAll('.rpl-commerce .shopify-section--collection-banner .collection-description').forEach(function(description){
   if(description.dataset.compactCollection)return;
   description.dataset.compactCollection='true';
   if(description.textContent.trim().length<260&&!description.querySelector('img,iframe,video'))return;
   var details=document.createElement('details');details.className='rpl-collection-details';
   var summary=document.createElement('summary');summary.textContent='More about this collection';details.appendChild(summary);
   while(description.firstChild)details.appendChild(description.firstChild);
   description.appendChild(details);
  });
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',compactCollections);else compactCollections();
 document.addEventListener('shopify:section:load',compactCollections);
})();

/* Vector link arrows render identically on iOS and desktop, without emoji fonts. */
(function(){
 function normalizeArrows(){ document.querySelectorAll('a,button').forEach(function(control){ var walker=document.createTreeWalker(control,NodeFilter.SHOW_TEXT),nodes=[],node; while(node=walker.nextNode())if(/[↗↘]/.test(node.nodeValue)&&!node.parentElement.closest('svg,script,style'))nodes.push(node); nodes.forEach(function(text){ var parts=text.nodeValue.split(/([↗↘])[︎️]?/),fragment=document.createDocumentFragment(); parts.forEach(function(part,index){ if(index%2===1){var svg=document.createElementNS('http://www.w3.org/2000/svg','svg');svg.setAttribute('viewBox','0 0 24 24');svg.setAttribute('aria-hidden','true');svg.setAttribute('focusable','false');svg.style.cssText='display:inline-block;width:1em;height:1em;min-width:1em;flex-shrink:0;vertical-align:-.12em;color:inherit';var path=document.createElementNS(svg.namespaceURI,'path');path.setAttribute('d',part==='↘'?'M5 5 19 19M5 19h14V5':'M5 19 19 5M5 5h14v14');path.setAttribute('fill','none');path.setAttribute('stroke','currentColor');path.setAttribute('stroke-width','1.8');path.setAttribute('stroke-linecap','round');path.setAttribute('stroke-linejoin','round');svg.appendChild(path);fragment.appendChild(svg);} else fragment.appendChild(document.createTextNode(part)); });text.replaceWith(fragment); }); }); }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',normalizeArrows);else normalizeArrows();
 document.addEventListener('shopify:section:load',normalizeArrows);
})();

/* Reassurance stays beside native purchase controls, including after variant rerenders. */
(()=>{function initConfidence(){const template=document.getElementById('rpl-product-confidence');if(!template)return;document.querySelectorAll('main .product-info__block-item[data-block-type="buy-buttons"]').forEach(block=>{const parent=block.parentElement;if(parent.querySelector('.rpl-buy-confidence'))return;block.before(template.content.cloneNode(true))})}if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initConfidence);else initConfidence();document.addEventListener('shopify:section:load',initConfidence);document.addEventListener('product:rerender',()=>requestAnimationFrame(initConfidence));})();

/* Remove obsolete backorder notes only when Shopify's selected variant says they are invalid. */
(()=>{
 let busy=false;const attempted=new Set();
 async function reconcileBackorders(){
  if(busy)return;const rows=[...document.querySelectorAll('line-item[data-rpl-stale-backorder]')];
  const row=rows.find(el=>el.dataset.rplLineKey&&!attempted.has(el.dataset.rplLineKey));if(!row)return;
  busy=true;const key=row.dataset.rplLineKey;attempted.add(key);
  try{
   const raw=JSON.parse(row.dataset.rplLineProperties||'{}');
   const properties=Array.isArray(raw)?Object.fromEntries(raw):raw;
   if(row.dataset.rplMto==='true')properties['Order type']='Made to Order';else {delete properties['Order type'];if(!Object.keys(properties).length)properties['Order type']='';}
   const response=await fetch((window.Shopify?.routes?.root||'/')+'cart/change.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({id:key,quantity:Number(row.dataset.rplLineQuantity),properties})});
   if(!response.ok)throw Error('Unable to refresh saved availability note');
   if(document.querySelector('[data-rpl-cart-section]'))document.dispatchEvent(new CustomEvent('rpl:cart-refresh'));
   else document.dispatchEvent(new CustomEvent('cart:refresh'));
  }catch(error){console.warn(error.message)}finally{busy=false;setTimeout(reconcileBackorders,150)}
 }
 if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',reconcileBackorders);else reconcileBackorders();
 for(const event of ['cart-drawer:refreshed','rpl:cart-render','shopify:section:load'])document.addEventListener(event,reconcileBackorders);
})();

// Keep the existing Essentials app beside the buying controls instead of the footer.
(() => {
 if (!location.pathname.includes('/products/') || new URLSearchParams(location.search).get('view') === 'wholesale') return;
 const refresh = () => {
  const buy = document.querySelector('.product-info [data-block-type="buy-buttons"]');
  const bundle = document.querySelector('.cbb-frequently-bought-container');
  if (document.querySelector('[data-smart-recommendations]:not([hidden])') && bundle) bundle.hidden = true;
  if (buy && bundle && !document.querySelector('[data-smart-recommendations]:not([hidden])') && buy.nextElementSibling !== bundle) buy.after(bundle);
  document.querySelectorAll('.bcpo-label label, .bcpo-title, .bcpo-simple label').forEach(label => {
   const walker = document.createTreeWalker(label, NodeFilter.SHOW_TEXT);
   let text;
   while ((text = walker.nextNode())) {
    if (/use the tool above or describe your design\s*:/i.test(text.nodeValue)) {
     text.nodeValue = text.nodeValue.replace(/use the tool above or describe your design\s*:/ig, 'Optional Customization: describe or upload your design.');
    }
   }
  });
  document.querySelectorAll('.bcpo-textarea').forEach(description => {
   const title = description.querySelector('.bcpo-title');
   if (!title || !/Optional Customization: describe or upload your design/i.test(title.textContent) || description.closest('.rpl-customization-panel')) return;
   const upload = description.nextElementSibling;
   const hasUpload = upload && upload.matches('.bcpo-file') && /upload.*design/i.test(upload.textContent);
   const panel = document.createElement('fieldset');
   panel.className = 'rpl-customization-panel';
   const legend = document.createElement('legend'); legend.textContent = 'Optional customization';
   const note = document.createElement('p');note.className = 'rpl-customization-note';note.textContent = 'Describe or upload your design. You can leave these fields blank.';
   description.before(panel);panel.append(legend,note,description);if(hasUpload)panel.append(upload);
   title.textContent = 'Describe your design (optional)';
   if(hasUpload){const uploadTitle=upload.querySelector('.bcpo-title');if(uploadTitle)uploadTitle.textContent='Upload your design (optional)';}
  });
  document.querySelectorAll('.bcpo-simple').forEach(row => {
   const label = row.querySelector('label');
   const bootTitle = document.body.dataset.rplProductTitle || '';
   const stockBoot = (document.body.dataset.rplProductType === 'boots' || /made[ -]to[ -]order/i.test(bootTitle)) && !/full[ -]custom|custom boot experience/i.test(bootTitle);
   if (stockBoot && label && /initials? (?:on pulls|colou?r)/i.test(label.textContent)) { row.hidden = true; row.style.setProperty('display','none','important'); document.querySelectorAll('.rpl-initials-heading').forEach(el => el.remove()); row.querySelectorAll('input,select,textarea').forEach(input => {input.disabled=true;input.required=false;if(input.type==='radio'||input.type==='checkbox')input.checked=false;else input.value='';});return; }
   if (!label || !/^Initial Colou?r\s*:?$/i.test(label.textContent.trim())) return;
   label.textContent = 'Initials color (on leather pulls only)';
   if (!document.querySelector('.rpl-initials-heading')) {
    const first = [...document.querySelectorAll('.bcpo-simple')].find(el => /Initials on Pulls/i.test(el.textContent)) || row;
    const heading = document.createElement('div'); heading.className = 'rpl-initials-heading';
    heading.innerHTML = '<h3>Optional initials on leather pulls</h3><p>These choices personalize your initials only. They do not change the boot color.</p>';
    first.before(heading);
   }
  });
 };
 let pending = false;
 const observer = new MutationObserver(() => {if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;refresh();});});
 observer.observe(document.body,{childList:true,subtree:true});refresh();
})();

(() => {
 const style=document.createElement('style');style.textContent=`
 .rpl-customization-panel{min-width:0;width:100%;box-sizing:border-box;margin:20px 0;padding:16px 18px 18px;border:1px solid #bba581;background:#e8dcc5;border-radius:4px}
 .rpl-customization-panel legend{padding:0 7px;font-size:16px;font-weight:600;color:#0b2c38}
 .rpl-customization-panel .rpl-customization-note{font-size:14px;line-height:1.5;margin:0 0 14px;color:#415459}
 .rpl-customization-panel .bcpo-simple{margin:0!important;padding:0!important}
 .rpl-customization-panel .bcpo-simple+.bcpo-simple{margin-top:16px!important}
 .rpl-customization-panel .bcpo-label{margin-bottom:7px}
 .rpl-customization-panel textarea,.rpl-customization-panel input[type=file]{max-width:100%;box-sizing:border-box;background:#f6efe3}
 .rpl-customization-panel textarea{width:100%;min-height:85px}
 @media(max-width:600px){.rpl-customization-panel{padding:12px 14px 14px}.rpl-customization-panel .bcpo-title{font-size:15px}}
 `;document.head.append(style);
})();

/* Initials are optional. Require a color only when initials are entered. */
(() => {
 function syncInitials() {
  const initials=document.querySelector('input[name^="properties["][name*="Initials on Pulls"]');
  if(!initials)return;
  const needed=!initials.disabled&&initials.value.trim().length>0;
  document.querySelectorAll('input[name="properties[Initial Color]"]').forEach(input=>{input.required=needed;});
 }
 document.addEventListener('input',syncInitials,true);
 document.addEventListener('change',syncInitials,true);
 let pending=false;
 new MutationObserver(()=>{if(pending)return;pending=true;requestAnimationFrame(()=>{pending=false;syncInitials();});}).observe(document.body,{childList:true,subtree:true});
 syncInitials();
})();

